/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { Alert } from 'sarsaparilla';
import uniqueId from 'lodash/uniqueId';

import {
    parseFormattedErrorMessageString,
    parseErrorMessageIntoStringList,
} from '../utils/handleBackEndError';

type BodyProps = {
    children: React.ReactNode;
};

function Body({ children }: BodyProps) {
    if (Array.isArray(children)) {
        return (
            <ul>
                {children?.map((e) => (
                    <li key={uniqueId()}>{e}</li>
                ))}
            </ul>
        );
    }
    return <> {children} </>;
}

export type ErrorNotificationProps = {
    isShow: boolean;
    dismiss?: () => void;
    body?: string;
    title?: string;
    className?: string;
};
export default function ErrorNotification({
    isShow = false,
    dismiss,
    body,
    title = "You've encountered the following error(s):",
    className,
}: ErrorNotificationProps) {
    return (
        !!isShow && (
            <div aria-live="polite">
                <Alert
                    className={className}
                    type="error"
                    heading={title}
                    shouldFocusOnMount
                    hasAriaLive
                    showCloseButton
                    onCloseButtonClick={dismiss}
                >
                    <Body>
                        {parseErrorMessageIntoStringList(
                            parseFormattedErrorMessageString(body)
                        )}
                    </Body>
                </Alert>
            </div>
        )
    );
}
